import Typography from "@mui/material/Typography";
import React from "react";
import { type SetterOrUpdater, useRecoilState, useRecoilValue } from "recoil";
import CustomSelect from "../components/CustomSelect";
import { weekOptions as defaultWeekOptions } from "../constants";
import { localeState, weekState } from "../store";
import Grid2 from "@mui/material/Grid2";
import type { SelectOptions } from "../types";

export default function Week() {
	const [week, setWeek] = useRecoilState(weekState);
	const resolvedLocale = useRecoilValue(localeState);
	const [weekOptions, setWeekOptions] = React.useState(
		defaultWeekOptions(resolvedLocale.weekDaysOptions),
	);

	return (
		<>
			<Grid2 container>
				<Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
					<Typography>{resolvedLocale.onText}</Typography>
					<CustomSelect
						options={weekOptions}
						label={resolvedLocale.dayOfWeekLabel}
						value={week}
						setValue={
							setWeek as SetterOrUpdater<SelectOptions | SelectOptions[]>
						}
						disableClearable
						sort
						disableEmpty
					/>
				</Grid2>
			</Grid2>
		</>
	);
}
